import { Directive, ElementRef, OnInit } from '@angular/core';
import { AppService } from '../services';
import { FullScreenViewerOptions, FullScreenViewerService } from '../services/full-screen-viewer.service';

@Directive({
  selector: '[videoReplicateControls]'
})
export class VideoReplicateControlsDirective implements OnInit {

  private video: HTMLVideoElement;
  private progress: HTMLProgressElement;
  private playPauseButton: HTMLButtonElement;
  private muteButton: HTMLButtonElement;
  private fullScreenButton: HTMLButtonElement;
  private volumeSlider: HTMLInputElement;

  ngOnInit() {
    this.video = this.el.nativeElement;

    // Create progress bar
    this.progress = document.createElement('progress');
    this.progress.setAttribute('max', this.video.duration.toString());
    this.progress.addEventListener('click', (event) => {
      const target = <HTMLProgressElement>event.target;
      const percent = event.offsetX / target.offsetWidth;
      this.video.currentTime = percent * this.video.duration;
    });
    this.video.addEventListener('timeupdate', () => {
      this.progress.value = this.video.currentTime;
    });
    this.el.nativeElement.parentNode.insertBefore(this.progress, this.el.nativeElement.nextSibling);

    // Create play/pause button
    this.playPauseButton = document.createElement('button');
    this.playPauseButton.textContent = 'Play';
    this.playPauseButton.addEventListener('click', () => {
      if (this.video.paused) {
        this.video.play();
        this.playPauseButton.textContent = 'Pause';
      } else {
        this.video.pause();
        this.playPauseButton.textContent = 'Play';
      }
    });
    this.el.nativeElement.parentNode.insertBefore(this.playPauseButton, this.progress.nextSibling);

    // Create mute button
    this.muteButton = document.createElement('button');
    this.muteButton.textContent = 'Mute';
    this.muteButton.addEventListener('click', () => {
      if (this.video.muted) {
        this.video.muted = false;
        this.muteButton.textContent = 'Mute';
      } else {
        this.video.muted = true;
        this.muteButton.textContent = 'Unmute';
      }
    });
    this.el.nativeElement.parentNode.insertBefore(this.muteButton, this.playPauseButton.nextSibling);

    // Create volume slider
    this.volumeSlider = document.createElement('input');
    this.volumeSlider.setAttribute('type', 'range');
    this.volumeSlider.setAttribute('min', '0');
    this.volumeSlider.setAttribute('max', '1');
    this.volumeSlider.setAttribute('step', '0.01');
    this.volumeSlider.setAttribute('value', this.video.volume.toString());
    this.volumeSlider.addEventListener('input', () => {
      this.video.volume = parseFloat(this.volumeSlider.value);
    });
    this.el.nativeElement.parentNode.insertBefore(this.volumeSlider, this.muteButton.nextSibling);

    // Create Full Screen
    this.fullScreenButton = document.createElement('button');
    this.fullScreenButton.textContent = 'Full screen';
    this.fullScreenButton.addEventListener('click', () => {
        const src = this.video.getElementsByTagName("source")[0].src;
        this.showImage(src);
    });
    this.el.nativeElement.parentNode.insertBefore(this.fullScreenButton, this.progress.nextSibling);
  }

  constructor(
    private el: ElementRef,
    private appService: AppService,
    private fullScreenViewer: FullScreenViewerService
    ) { }

  async showImage(url: string) {
    const imageObject: FullScreenViewerOptions[] = [{ image: url, title: '' }];
    await this.fullScreenViewer.openViewer(imageObject);
  }

}